/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reason for the insurance request resp. business transaction.   (german: Angebotsgrund)     * `VehicleChange`   - german: Fahrzeugwechsel   * `InsurerChange`   - german: Versichererwechsel   * `FirstInsurance`  - german: Erstversicherung, Neugeschäft   * `TariffChange`    - german: Tarifwechsel
 */
export const InsuranceReason = {
  VehicleChange: 'VehicleChange',
  InsurerChange: 'InsurerChange',
  FirstInsurance: 'FirstInsurance',
  TariffChange: 'TariffChange',
} as const;
export type InsuranceReason = (typeof InsuranceReason)[keyof typeof InsuranceReason];
